/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Geolocation } from './Geolocation';
// @ts-ignore
import {
// @ts-ignore
    GeolocationFromJSON,
// @ts-ignore
    GeolocationFromJSONTyped,
// @ts-ignore
    GeolocationToJSON,
} from './Geolocation';

/**
 * 
 * @export
 * @interface SupplierAddress
 */
export interface SupplierAddress {
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    supplierId: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    building: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    street1: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    street2: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    region: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    countryCode: string;
    /**
     * 
     * @type {Geolocation}
     * @memberof SupplierAddress
     */
    location: Geolocation;
    /**
     * 
     * @type {string}
     * @memberof SupplierAddress
     */
    additionalDescription: string;
}

/**
 * Check if a given object implements the SupplierAddress interface.
 */
// @ts-ignore
export function instanceOfSupplierAddress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "supplierId" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "building" in value;
    isInstance = isInstance && "street1" in value;
    isInstance = isInstance && "street2" in value;
    isInstance = isInstance && "postalCode" in value;
    isInstance = isInstance && "region" in value;
    isInstance = isInstance && "city" in value;
    isInstance = isInstance && "countryCode" in value;
    isInstance = isInstance && "location" in value;
    isInstance = isInstance && "additionalDescription" in value;

    return isInstance;
}

// @ts-ignore
export function SupplierAddressFromJSON(json: any): SupplierAddress {
    return SupplierAddressFromJSONTyped(json, false);
}

// @ts-ignore
export function SupplierAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierAddress {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'supplierId': json['supplier_id'],
        'type': json['type'],
        'building': json['building'],
        'street1': json['street1'],
        'street2': json['street2'],
        'postalCode': json['postal_code'],
        'region': json['region'],
        'city': json['city'],
        'countryCode': json['country_code'],
        'location': GeolocationFromJSON(json['location']),
        'additionalDescription': json['additional_description'],
    };
}

// @ts-ignore
export function SupplierAddressToJSON(value?: SupplierAddress | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'supplier_id': value.supplierId,
        'type': value.type,
        'building': value.building,
        'street1': value.street1,
        'street2': value.street2,
        'postal_code': value.postalCode,
        'region': value.region,
        'city': value.city,
        'country_code': value.countryCode,
        'location': GeolocationToJSON(value.location),
        'additional_description': value.additionalDescription,
    };
}

